import { debounceTime, Subject } from 'rxjs';

import Component from './component';

class ResizeMonitor extends Component {
  private _cachedWidth: number = -1;

  private _widthChangeSubject = new Subject<number>();

  public constructor() {
    super('class', document.body);
  }

  public addWidthChangeListener(handler: (value: number) => void, debounceTimeMs = 0) {
    const subscription = debounceTimeMs
      ? this._widthChangeSubject.pipe(debounceTime(debounceTimeMs)).subscribe(handler)
      : this._widthChangeSubject.subscribe(handler);
    this._addSubscription(subscription);
  }

  private _handleResize() {
    if (window.innerWidth !== this._cachedWidth) {
      this._cachedWidth = window.innerWidth;
      this._widthChangeSubject.next(this._cachedWidth);
    }
  }

  protected _onEnter() {
    this._cachedWidth = window.innerWidth;
    this._addListener(window, 'resize', this._handleResize, 500);
  }
}

export default ResizeMonitor;
